import { useNavigate } from 'react-router-dom';
import WithdrawPix from '../withdrawals/components/WithdrawPix';

export default function PixKeyPage() {
  const navigate = useNavigate();
  return <WithdrawPix onClose={() => navigate('/access/saques')} asPage />;
}
